export const generateInvoiceNumber = () => {
  // Get the current date
  const date = new Date();
  const year = date.getFullYear().toString();
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed
  const day = date.getDate().toString().padStart(2, "0");

  // Generate a random number
  const randomNumber = Math.floor(1000 + Math.random() * 9000).toString(); // Random 4 digit number

  // Combine the date and random number to create the invoice number
  const invoiceNumber = `${year}${month}${day}-${randomNumber}`;

  return invoiceNumber;
};
